import { Button, CircularProgress, Stack, Typography } from '@mui/material';

export default function KnowledgeLibraryState({
    pending,
    error,
    hasData,
    onReload,
}: {
    pending: boolean;
    error: string;
    hasData: boolean;
    onReload: () => void;
}) {
    return (
        <Stack
            role={error ? 'alert' : pending ? 'status' : undefined}
            direction={{ xs: error ? 'column' : 'row', sm: 'row' }}
            alignItems={{ xs: error ? 'stretch' : 'center', sm: 'center' }}
            spacing={1}
            sx={{
                minHeight: 44,
                ...(error && {
                    p: 1.5,
                    borderRadius: 2,
                    bgcolor: 'var(--lm-danger-bg)',
                    border: '1px solid var(--lm-danger-border)',
                }),
            }}
        >
            {pending && (
                <CircularProgress
                    size={18}
                    aria-hidden="true"
                />
            )}
            <Typography sx={{ flex: 1, fontSize: 14, color: error ? 'var(--lm-danger-ink)' : 'var(--lm-muted)' }}>
                {error ||
                    (pending ? (hasData ? 'Обновляем список…' : 'Загружаем базы знаний…') : 'Готовые базы знаний')}
            </Typography>
            <Button
                onClick={onReload}
                disabled={pending}
                aria-label={error ? 'Повторить загрузку баз знаний' : 'Обновить список баз знаний'}
                sx={{
                    minHeight: 44,
                    flexShrink: 0,
                    textTransform: 'none',
                    fontFamily: 'inherit',
                    color: error ? 'var(--lm-danger-ink)' : 'var(--lm-muted)',
                }}
            >
                {error ? 'Повторить' : 'Обновить'}
            </Button>
        </Stack>
    );
}
